// Format a Date object as YYYY-MM-DD using its LOCAL calendar fields.
// Using `.toISOString()` on a locally-constructed Date converts to UTC first,
// which rolls back to the previous day for any timezone ahead of UTC (e.g. IST)
// during part of the day — causing "This Month" to start on the 31st instead
// of the 1st. This helper avoids that by reading local Y/M/D directly.
export const toLocalISODate = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};
